import * as types from "../../actions/actionsTypes/breadcrumbActionTypes";

export const initialStateBreadcrumb = {
    path: null
};

export const breadcrumbReducer = (state = initialStateBreadcrumb, action) => {
    switch (action.type) {
        case types.UPDATE_BREADCRUMB :
            return { path: action.path};
        default :
            return state
    }
};

